import { useState, useEffect } from 'react';
import crossFetch from 'cross-fetch';
import _ from 'lodash';
// import moment from 'moment';
import dayjs from 'dayjs';
import normalize from 'normalize-object';
import notifications from 'lib/notifications';
import inMemoryJWT from 'services/auth/inMemoryJWT';
import { yupToFormErrors } from 'formik';
import config from '../config';
import { renderDebugBtn, renderFormFillBtn } from './helpers';
const {
  baseUrl,
  encryption_secret_key,
  encryption_secret_iv,
  isApiEncryptionEnabled,
  isRouteEncryptionEnabled,
  requestHeaderAccessToken,
} = config;
import { priceFormatter, amountFormatter, quantityFormatter } from './formatters';
// import * as mockData from './mockData';
import storage from 'lib/storage';
import { toast } from 'react-toastify';
import ReactGA from 'react-ga';
import CryptoJS from 'crypto-js';
import apiErrorLogger from 'services/sentry/index';
import queryStringParser from 'query-string';
import { actions as systemActions } from 'redux/system';
import store from 'redux/store';
import { useSelector } from 'react-redux';

const loc = window.location.href;
const isUserOnboardingScreen = loc.includes('onboarding') && !loc.includes('isCreateAccount');
const tranfromObjectIntoWithFlatKeys = (obj) => {
  const temp = { ...obj };

  for (const key of Object.keys(obj)) {
    if (obj[key] && typeof obj[key] === 'object') {
      temp[utils.lowerStr(key)] = tranfromObjectIntoWithFlatKeys(obj[key]);
    } else {
      temp[utils.lowerStr(key)] = obj[key];
      temp[key.trim().toLowerCase()] = obj[key];
    }
  }

  const temp2 = {
    ...temp,
    ...obj,
  };

  return temp2;
};

const caculateFinalQuantity = (baseQuantity, periodicity, fromDate = new Date(), toDate = new Date()) => {
  // console.log('\n\n=====================================')
  // console.log('caculateFinalQuantity--->baseQuantity--->', baseQuantity)
  // console.log('caculateFinalQuantity--->periodicity--->', periodicity)
  // console.log('caculateFinalQuantity--->fromDate--->', fromDate)
  // console.log('caculateFinalQuantity--->toDate--->', toDate)
  // console.log('=====================================')
  let finalQuantity = baseQuantity;
  switch (periodicity) {
    case 2:
      finalQuantity = baseQuantity * (dayjs(toDate).diff(dayjs(fromDate), 'days') + 1);
      break;
    case 3:
      finalQuantity = baseQuantity * (dayjs(toDate).diff(dayjs(fromDate), 'weeks') + 1);
      break;
    case 4:
      const v1 = dayjs(toDate).diff(dayjs(fromDate), 'months', true);
      const v2 = Math.round(v1);
      finalQuantity = baseQuantity * v2;
      // finalQuantity = baseQuantity * dayjs(toDate).diff(dayjs(fromDate), 'months');
      break;
    case 5:
      finalQuantity = baseQuantity * (dayjs(toDate).diff(dayjs(fromDate), 'years') + 1);
      break;
  }

  return finalQuantity;
};

const formatLocationString = (location) => {
  if (typeof location === 'string') {
    const locationList = location
      .trim()
      .split(',')
      .filter((l) => {
        const temp = l.trim();
        if (temp !== 'India' && temp !== 'india') {
          return true;
        }
      });
    return locationList; // is array
  }

  return [];
};

const importPublicPrivetKey = (pem, type) => {
  // base64 decode the string to get the binary data
  const binaryDerString = window.atob(pem);
  // convert from a binary string to an ArrayBuffer
  function str2ab(str) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return buf;
  }
  const binaryDer = str2ab(binaryDerString);
  if (type === 'public') {
    return window.crypto.subtle.importKey(
      'spki',
      binaryDer,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      true,
      ['encrypt'],
    );
  } else {
    return window.crypto.subtle.importKey(
      'pkcs8',
      binaryDer,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      false,
      ['decrypt'],
    );
  }
};

const getRandomString = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

const iv = getRandomString(16);

export let encryption = (encryption_text) => {
  const key = CryptoJS.enc.Utf8.parse(encryption_secret_key);
  const iv = CryptoJS.enc.Utf8.parse(encryption_secret_iv);
  try {
    let encrypted = CryptoJS.AES.encrypt(encryption_text, key, {
      keySize: 256 / 32,
      iv: iv,
      mode: CryptoJS.mode.CBC,
    });
    return encrypted.toString(CryptoJS.format.Utf8);
  } catch (error) {
    console.log('Encryption Error', error);
    throw error;
  }
};

export let decryption = (decryption_text) => {
  const key = CryptoJS.enc.Utf8.parse(encryption_secret_key);
  const iv = CryptoJS.enc.Utf8.parse(encryption_secret_iv);
  try {
    let decrypted = CryptoJS.AES.decrypt(decryption_text, key, {
      keySize: 256 / 32,
      iv: iv,
      mode: CryptoJS.mode.CBC,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.log('Decryption Error', error);
    // throw error;
    return false;
  }
};

export let encryptionInHex = (encryption_text) => {
  if (isRouteEncryptionEnabled == 'false') {
    return encryption_text;
  }
  if (encryption_text) {
    const key = CryptoJS.enc.Utf8.parse(encryption_secret_key);
    const iv = CryptoJS.enc.Utf8.parse(encryption_secret_iv);
    try {
      let encrypted = CryptoJS.AES.encrypt(encryption_text?.toString(), key, {
        keySize: 256 / 32,
        iv: iv,
        mode: CryptoJS.mode.CBC,
      });
      return encrypted.toString(CryptoJS.format.Hex);
    } catch (error) {
      console.log('Encryption Error', error);
      throw error;
    }
  }
};

export let decryptionInHex = (decryption_text) => {
  if (isRouteEncryptionEnabled == 'false') {
    return decryption_text;
  }
  if (decryption_text) {
    const key = CryptoJS.enc.Utf8.parse(encryption_secret_key);
    const iv = CryptoJS.enc.Utf8.parse(encryption_secret_iv);
    var encryptedHex = CryptoJS.enc.Hex.parse(decryption_text);
    var encryptedBase64 = CryptoJS.enc.Base64.stringify(encryptedHex);
    try {
      let decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
        keySize: 256 / 32,
        iv: iv,
        mode: CryptoJS.mode.CBC,
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Decryption Error', error);
      return false;
    }
  }
};

export const getUrlWithEncryptedQueryParams = (url) => {
  if (isRouteEncryptionEnabled === 'false') {
    return url;
  }
  const urlObj = url && url?.split('?');
  const routeUrl = urlObj?.[0]
    ?.split('/')
    ?.map((item) => (isNaN(item) ? item : encryptionInHex(item)))
    ?.join('/');
  const queryParams = urlObj?.[1] ? '?' + encryptionInHex(urlObj?.[1]) : '';
  return routeUrl + queryParams;
};

export const getDecryptedUrl = (url) => {
  if (isRouteEncryptionEnabled == 'false') {
    return url;
  }
  const safeDecodeURIComponent = (str) => {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  };
  const tryDecryptQuery = (q) => {
    if (!q) return '';
    const decoded = safeDecodeURIComponent(q);
    // Try hex-first (current default)
    const byHex = decryptionInHex(decoded);
    if (byHex) return byHex;
    // Fallback to base64 (handles links like t4KhEji6r8CT/yll...)
    const byB64 = decryption(decoded);
    if (byB64) return byB64;
    // Last attempt without decodeURIComponent
    const byB64Raw = decryption(q);
    if (byB64Raw) return byB64Raw;
    return false;
  };
  const extractedUrl = new URL(url)?.pathname + new URL(url)?.search;
  const urlObj = extractedUrl?.split('?');
  const routeUrl = urlObj?.[0]
    ?.split('/')
    ?.map((item) => (decryptionInHex(item) ? decryptionInHex(item) : item))
    ?.join('/');
  const queryParams = urlObj?.[1]
    ? tryDecryptQuery(urlObj?.[1])
      ? '?' + tryDecryptQuery(urlObj?.[1])
      : `?${urlObj?.[1]}`
    : '';
  return new URL(url)?.origin + routeUrl + queryParams;
};

export const getDecryptedRouteParams = (params) => {
  if (isRouteEncryptionEnabled == 'false') {
    return params;
  }
  let decryptedParams = {};
  if (!_.isEmpty(params)) {
    for (const [key, value] of Object.entries(params)) {
      decryptedParams[key] = decryptionInHex(value) ? decryptionInHex(value) : value;
    }
  }
  return decryptedParams;
};
const isExcludedFromEncryption = (reqUrl) => {
  const excludeEncryptionApiArray = [
    'CreateSocialPost',
    'EditPost',
    'SaveAndUpdateAuthorizedSignatory',
    'AttachDocument_Azure',
    'AddGreenChannelAgreementVersion',
    'UpdateAndUploadBanner',
    'UpdateProfile',
    'AttachDocumentAzureStorage',
    'ImportMembers',
    'ImportFarmers',
    // 'UploadAboutImage',
  ];
  const utlPath = new URL(reqUrl)?.pathname?.split('/');
  const apiToExclude = utlPath[utlPath?.length - 1];
  return excludeEncryptionApiArray.includes(apiToExclude);
};

const utils = {
  isLiquidFormCommodityUnitInMT(commodityForm, commodity) {
    if (commodityForm == 'Liquid' || commodityForm == 'liquid') {
      if (
        commodity == 'Cashew Nut Shell' ||
        commodity == 'Groundut Oil' ||
        commodity == 'Palm Oil' ||
        commodity == 'Sunflower Oil'
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  getSpecificDecimalRoundedNumber(number, decimalsToShow) {
    if (Number.isInteger(parseFloat(number))) {
      return number;
    } else if (`${number}`.split('.')?.[1]?.length <= decimalsToShow) {
      return number;
    } else if (`${number}`.split('.')?.[1]?.length > decimalsToShow) {
      return number.toFixed(decimalsToShow);
    }
  },
  scrollToBottom(reactRef) {
    if (reactRef) {
      reactRef.current.scrollTop = reactRef.current.scrollHeight;
    }
  },
  isDecimal(num) {
    if (num % 1 != 0) {
      return true;
    } else {
      return false;
    }
  },
  // getMockRes(key) {
  //   return _.get(mockData, key);
  // },
  getUnixTs(dt = '') {
    return dayjs(dt).unix();
  },
  debugStr(str) {
    if (utils.isProd()) {
      return null;
    }

    return str;
  },
  // debug(data) {
  //   return renderDebugBtn({ data });
  // },
  // fillBtn(formikBag, dataKey) {
  //   return renderFormFillBtn({ dataKey, formikBag });
  // },
  getACL(user) {
    if (!user) {
      user = _.get(globalThis, 'user') || {};
    }
    const uType = _.get(user, 'profile.person.type_of_individual_enum') || 0;
    const companyAdmin = _.get(user, 'profile.person.is_company_admin');
    const hasRole = !!uType;
    const isEmailLogin = (_.get(user, 'profile.login_through_enum') || 0) === 2;
    const isPhoneLogin = (_.get(user, 'profile.login_through_enum') || 0) === 1;
    const isCompanyAdmin = _.get(user, 'profile.person.is_company_admin') || false;
    const isInvited = _.get(user, 'profile.person.is_invited') || false;
    let isCompany = false;
    const userTypeEnum = _.get(user, 'profile.person.user_type_enum');
    if (userTypeEnum === 1) {
      // removing && isCompanyAdmin === true condition so that every team member gets enterprise treatment
      isCompany = true;
    }
    let isUserCompany; // need to remove this and use isCompany and isCompanyAdmin flags
    const isFarmer = uType === 1;
    const isQALab = uType === 8;
    const isAgriBio = uType === 3;
    const isDriver = _.get(user, 'profile.person.is_driver') || false;
    const isTransporter = _.get(user, 'profile.person.is_transporter') || false;
    const isControlTowerUser = _.get(user, 'profile.person.is_control_tower_user') || false;
    // const isRelatedBusinessUser = (_.get(user, 'profile.type_of_individual_enum') || 0) === 3;
    const isChecker = _.get(user, 'profile.person.is_checker') || false;
    const isMaker = _.get(user, 'profile.person.is_maker') || false;
    const isSuperUser = _.get(user, 'profile.person.is_superuser') || false;

    if (userTypeEnum === 1 && companyAdmin === false) {
      isUserCompany = true;
    } else {
      isUserCompany = false;
    }

    const isIndividual = hasRole && !isCompany && !isUserCompany;

    let canUpdateEmail = false;
    let canUpdatePhone = false;
    let isEmailDisabled = false;
    let isPhoneDisabled = false;

    if (isEmailLogin) {
      isEmailDisabled = true;
      canUpdateEmail = true;
    }

    if (isPhoneLogin) {
      isPhoneDisabled = true;
      canUpdatePhone = true;
    }

    if (isInvited) {
      canUpdateEmail = false;
      isEmailDisabled = true;
    }

    let acl = {
      isEmailLogin,
      isPhoneLogin,
      isCompanyAdmin,
      isInvited,
      isIndividual,
      isFarmer,
      isQALab,
      isAgriBio,
      isDriver,
      isTransporter,
      isCompany,
      isUserCompany,
      canUpdateEmail,
      canUpdatePhone,
      isEmailDisabled,
      isPhoneDisabled,
      hasRole,
      isControlTowerUser,
      isChecker,
      isMaker,
      isSuperUser,
    };

    // console.log('\n\n===========ACL===========');
    // console.log('\n-------->acl', acl);
    // console.log('\n\n===========/ACL===========');

    return acl;
  },

  getQs(params = {}) {
    let queryString = queryStringParser.stringify(params);
    queryString = queryStringParser.parse(queryString);
    queryString = Object.keys(queryString)
      .map((key) => `${key}=${params[key]}`)
      .join('&');
    let encryptedBody = encryption(queryString);
    return isApiEncryptionEnabled === 'true' ? encryptedBody : queryString;
  },
  getLocationData(data) {
    data = data || {};
    const defaultValues = {
      location_id: 0,
      location_code: '',
      address_text: '',
      lattitude: '',
      longitude: '',
      village_id: 0,
      village_code: '',
      taluka_id: 0,
      taluka_code: '',
      city_id: 0,
      city_code: '',
      district_id: 0,
      district_code: '',
      state_id: 0,
      state_code: '',
      country_id: 0,
      country_code: '',
      // pin_code: '',
    };

    let locationData = _.pick(data, Object.keys(defaultValues));

    if (!locationData['location_code'] && data['location_data']) {
      locationData['location_code'] = data['location_data'];
    }

    if (!locationData['address_text'] && data['location_code']) {
      locationData['address_text'] = data['location_code'];
    }

    return {
      ...defaultValues,
      ...locationData,
    };
  },
  getAddressDisplayText(locationData) {
    let address = [];
    let line1 = [];
    let line2 = [];
    let line3 = [];
    if (locationData['address_line1']) {
      line1.push(locationData['address_line1']);
    }

    if (locationData['address_line2']) {
      line1.push(locationData['address_line2']);
    }

    if (locationData['address_line3']) {
      line1.push(locationData['address_line3']);
    }

    if (locationData['village_code']) {
      line2.push(locationData['village_code']);
    }

    if (locationData['taluka_code']) {
      line2.push(locationData['taluka_code']);
    }

    if (locationData['district_code']) {
      line2.push(locationData['district_code']);
    }

    if (locationData['state_code']) {
      line3.push(locationData['state_code']);
    }

    if (locationData['pin_code']) {
      line3.push(locationData['pin_code']);
    }

    return {
      line1,
      line2,
      line3,
      addStr: `${line1.join(',')} <br/> ${line2.join(',')} <br/> ${line3.join('-')}`,
    };
  },

  getFarmAddress(locationData) {
    let address = [];
    let line1 = [];
    let line2 = [];
    let line3 = [];
    if (locationData['address_line1']) {
      line1.push(locationData['address_line1']);
    }

    if (locationData['address_line2']) {
      line1.push(locationData['address_line2']);
    }

    if (locationData['village_code']) {
      line2.push(locationData['village_code']);
    }

    if (locationData['taluka_code']) {
      line2.push(locationData['taluka_code']);
    }

    if (locationData['district_code']) {
      line2.push(locationData['district_code']);
    }

    if (locationData['state_code']) {
      line3.push(locationData['state_code']);
    }

    if (locationData['pin_code']) {
      line3.push(locationData['pin_code']);
    }
    // if (locationData['circle_code']) {
    //   line4.push('(' + locationData['circle_code'] + ')');
    // }

    return {
      line1,
      line2,
      line3,
      addStr: `${line1.join(',')}\n${line2.join(',')}\n${line3.join('-')}`,
    };
  },

  getLocationAddress(locationData) {
    // console.log('locationData', locationData);
    let address = [];
    let add1 = [];
    let line1 = [];
    let line2 = [];
    let line3 = [];
    if (locationData['address_line1']) {
      add1.push(locationData['address_line1']);
    }

    if (locationData['address_line2']) {
      line1.push(locationData['address_line2']);
    }
    if (locationData['address_line3']) {
      line1.push(locationData['address_line3']);
    }

    if (locationData['village_code']) {
      line2.push(locationData['village_code']);
    }

    if (locationData['taluka_code']) {
      line2.push(locationData['taluka_code']);
    }

    if (locationData['district_code']) {
      line2.push(locationData['district_code']);
    }

    if (locationData['state_code']) {
      line3.push(locationData['state_code']);
    }

    if (locationData['pin_code']) {
      line3.push(locationData['pin_code']);
    }
    // if (locationData['circle_code']) {
    //   line4.push('(' + locationData['circle_code'] + ')');
    // }

    return {
      line1,
      line2,
      line3,
      addStr: `${add1.join(',')}\n${line1.join(',')}\n${line2.join(',')}\n${line3.join('-')}`,
    };
  },

  async validateSchema(schema, values) {
    try {
      let result = await schema.validate(values, {
        abortEarly: false,
      });
      return result;
    } catch (err) {
      // console.log('\n\n==============validateSchema===========');
      // console.log('validateSchema-->errors---->', err);
      // console.log('schema---->', schema);
      // console.log('values---->', values);
      // console.log('\n\n==============validateSchema===End========');

      throw {
        errors: yupToFormErrors(err),
        message: 'Schema validation error',
      };
    }
  },

  getErrMessage(errors = {}) {
    const loc = window.location.href;
    const isProdInstance = loc.includes('supply.biofuelcircle.com') || loc.includes('my.biofuelcircle.com');
    if (Object.keys(errors) === 0) {
      return '';
    }

    let errMessage = '';
    let key = _.first(Object.keys(errors));
    let val = errors[key];
    if (typeof val === 'object') {
      errMessage = utils.getErrMessage(errors[key]);
    } else if (typeof val === 'string') {
      errMessage = isProdInstance ? val : `${key} - ${val}`;
    }

    return errMessage;
  },
  displayMessage(message = '', type = 'info') {
    // notifications.show({
    //   type: type,
    //   message: message,
    //   key: 'req-form',
    //   duration: 20,
    // });
    if (type === 'info') {
      toast.info(message);
    } else if (type === 'success') {
      toast.success(message);
    } else if (type === 'error') {
      toast.error(message);
    } else if (type === 'warning') {
      toast.warn(message);
    }
  },
  displayErrors(err, formikBag = false, customId = '') {
    let errors = _.get(err, 'errors') || {};
    let errMessage = navigator.onLine
      ? _.get(err, 'message') || 'Unable to process request.'
      : 'Please check your internet connection.';
    if (!_.isEmpty(errors)) {
      if (formikBag) {
        formikBag.setErrors({
          ...errors,
        });

        // formikBag.setTouched({
        //   ...errors,
        //   // formData: {
        //   //   ...errors,
        //   // },
        // });
      }

      // let errData = _.flatMapDeep(errors);
      errMessage = utils.getErrMessage(errors) || errMessage;

      // console.log('\n\n==============displayErrors===========');
      // console.log('err', err);
      // console.log('errors->', errors);
      // console.log('formikBag---->', formikBag);
      // // console.log('flatMapDeep--->errData-->', errData);
      // console.log('errMessage---->', errMessage);
      // console.log('\n\n==============displayErrors===End========');
    }
    // notifications.show({
    //   type: 'error',
    //   message: errMessage,
    //   key: 'req-form',
    //   duration: 20,
    // });

    // if (errMessage.includes('JWT Token Not Found in the System')) {
    //   console.log('utils->displayErrors->errMessage', errMessage);
    //   errMessage = 'You have been logged out to protect your account.';
    // }

    const lowerMsg = String(errMessage || '').toLowerCase();
    const isNetworkLike =
      !navigator.onLine ||
      lowerMsg.includes('internet connection') ||
      lowerMsg.includes('network request failed') ||
      lowerMsg.includes('request timeout') ||
      lowerMsg.includes('aborted');
    if (isNetworkLike) {
      // Suppress toast here; fetch layer handles a single offline toast with global de-duplication
      return;
    }

    if (!lowerMsg.includes('jwt token not found in the system')) {
      notifications.show({ type: 'error', message: errMessage });
    }
  },
  displayFormDataErrors(err, formikBag = false) {
    // console.log('\n\n==========================\n\n');
    // console.log('displayFormDataErrors');
    // console.log('need to remove');
    // console.warn('need to remove');
    // console.error('need to remove');
    // console.log('\n\n==========================\n\n');

    let errors = _.get(err, 'errors') || {};
    let errMessage = _.get(err, 'message') || 'Unable to process request.';
    if (!_.isEmpty(errors)) {
      if (formikBag) {
        formikBag.setErrors({
          formData: {
            ...errors,
          },
        });

        // formikBag.setTouched({
        //   ...errors,
        //   formData: {
        //     ...errors,
        //   },
        // });
      }

      // let errData = _.flatMapDeep(errors);
      errMessage = utils.getErrMessage(errors) || errMessage;

      // console.log('\n\n==============displayErrors===========');
      // console.log('err', err);
      // console.log('errors->', errors);
      // console.log('formikBag---->', formikBag);
      // // console.log('flatMapDeep--->errData-->', errData);
      // console.log('errMessage---->', errMessage);
      // console.log('\n\n==============displayErrors===End========');
    }
    notifications.show({
      type: 'error',
      message: errMessage,
      key: 'req-form',
      duration: 20,
    });
  },

  isProd: () => {
    return config.isProd;
  },

  decodeJWT(token) {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  },

  async getResJSON(res) {
    // debugger;
    // console.log('getLocations-res-raw->', res);

    if (!res.ok) {
      throw res;
    }

    if (res.status < 200 || res.status >= 300) {
      throw res;
    }

    let jsonRes = res;

    if (typeof res.json === 'function') {
      jsonRes = await res.json();
    }

    if (_.get(jsonRes, 'stat', '') === false) {
      throw jsonRes;
    }

    return jsonRes;
  },

  async processApiRes(res = {}) {
    const isExcluded = isExcludedFromEncryption(res?.url);

    let resJSON = res;
    resJSON = isApiEncryptionEnabled === 'true' && !isExcluded ? await res.text() : res;

    if (isApiEncryptionEnabled === 'true' && !isExcluded) {
      let decryptedData = decryption(resJSON);
      resJSON = JSON.parse(decryptedData);
      if (!resJSON?.stat) {
        throw resJSON;
      }
    } else if (typeof res.json === 'function') {
      resJSON = await utils.getResJSON(resJSON);
    }

    const resData = _.get(resJSON, 'data', {}) || {};
    let snakeRes = normalize(resData, 'snake');
    return snakeRes;

    // if (_.isArray(resData)) {
    //   const updatedData = [];

    //   for (const d of resData) {
    //     const temp = tranfromObjectIntoWithFlatKeys(d);
    //     updatedData.push(temp);
    //   }

    //   return {
    //     ...updatedData,
    //     ...snakeRes,
    //   };
    // }

    // for (const key of Object.keys(resData)) {
    //   resData[utils.lowerStr(key)] = resData[key];
    // }

    // return {
    //   ...resData,
    //   ...snakeRes,
    // };
  },

  async processApiResELoc(res = {}) {
    let resJSON = res;
    if (typeof res.json === 'function') {
      resJSON = await utils.getResJSON(res);
    }

    const resData = _.get(resJSON, 'suggestedLocations', {}) || {};
    let snakeRes = normalize(resData, 'snake');
    return snakeRes;
  },

  getBackendParams(backendFields = {}, params = {}) {
    // let backendParams = {}
    for (const field in backendFields) {
      const frontendField = utils.lowerStr(field);
      const lowerCasedField = field.trim().toLowerCase();

      if (params[field] !== undefined) {
        backendFields[field] = params[field];
      } else if (params[frontendField] !== undefined) {
        backendFields[field] = params[frontendField];
      } else if (params[lowerCasedField] !== undefined) {
        backendFields[field] = params[lowerCasedField];
      }
    }
    return backendFields;
  },

  async processApiErrors(err = {}, fetchDetails = '', apiName = '') {
    console.log('BFC-LOGGER - processApiErrors called');
    console.log('BFC-LOGGER - err', err);
    console.log('BFC-LOGGER - fetchDetails', fetchDetails);
    console.log('BFC-LOGGER - apiName', apiName);
    const errData = {
      errors: {},
    };
    if (err.status === 400) {
      errData.errors = _.get(err, 'data', {}) || {};
      errData.message = _.get(err, 'message', 'Bad Request') || 'Bad Request';
      return errData;
    }

    if (err.status === 401) {
      // Check if this 401 might be due to a network issue (e.g., during retry after timeout)
      const message = _.get(err, 'message', '').toLowerCase();
      const isNetworkRelated =
        message.includes('network request failed') ||
        message.includes('aborted') ||
        message.includes('timeout') ||
        err.status === 503 ||
        err.status === 502 ||
        err.status === 504;

      // If the 401 appears to be network-related, don't attempt refresh or logout
      // This can happen when a network timeout retry returns 401
      if (isNetworkRelated) {
        console.log('BFC-LOGGER - 401 error appears network-related, not logging out');
        errData.errors = {};
        errData.message = 'Network error or timeout. Please check your connection.';
        return errData;
      }

      // Try token refresh before forcing logout
      console.log('BFC-LOGGER - 401 error detected, attempting token refresh');
      const result = await inMemoryJWT.getRefreshedToken();
      if (!result) {
        // Before logging out, check if we're online and if tokens still exist in storage
        // This prevents logout during network outages
        const isOnline = typeof navigator !== 'undefined' && 'onLine' in navigator && navigator.onLine;
        try {
          const hasTokens = await inMemoryJWT.checkTokens();
          if (!hasTokens && isOnline) {
            // Tokens are truly missing and we're online - safe to logout
            console.log('BFC-LOGGER - Token refresh failed on 401, tokens missing, online - forcing logout');
            return utils.forceLogout();
          } else if (!isOnline) {
            // We're offline - don't logout, might be temporary network issue
            console.log('BFC-LOGGER - Token refresh failed on 401 but offline - deferring logout');
            errData.errors = {};
            errData.message = 'Network error. Please check your connection.';
            return errData;
          } else {
            // Tokens still exist - might be a temporary refresh failure
            console.log('BFC-LOGGER - Token refresh failed on 401 but tokens still exist - not logging out');
            errData.errors = {};
            errData.message = 'Authentication error. Please try again.';
            return errData;
          }
        } catch (checkErr) {
          // If we can't check tokens, be conservative and only logout if online
          if (isOnline) {
            console.log('BFC-LOGGER - Token refresh failed on 401, token check failed, online - forcing logout');
            return utils.forceLogout();
          } else {
            console.log('BFC-LOGGER - Token refresh failed on 401, token check failed, offline - deferring logout');
            errData.errors = {};
            errData.message = 'Network error. Please check your connection.';
            return errData;
          }
        }
      }
      console.log('BFC-LOGGER - Token refresh successful on 401, continuing');
      // If refresh succeeded, don't force logout - let the request retry
      return errData;
    }
    const message = _.get(err, 'message', '');
    // Only logout on explicit 401/511/backend errors, not on network timeouts
    if (message === 'Network request failed' || message === 'Aborted') {
      errData.errors = {};
      errData.message = 'Network error or timeout. Please check your connection.';
      // Suppress toast here; fetch layer handles a single offline toast with global de-duplication
      return errData;
    }

    if (err.status === 500) {
      errData.errors = {
        500: 'Internal Server Error',
      };
      errData.message = '500 - Internal Server Error';
      return errData;
    }
    const searchString = 'JWT Token Not Found in the System';
    if (
      err.status === 511 ||
      (err.status == false && err.message.includes('Session Expired')) ||
      (fetchDetails == 'fetchPersonalDetails' && err.status === 511) ||
      err?.message?.toLowerCase().includes(searchString.toLowerCase())
    ) {
      // await apiErrorLogger(err);
      console.log('BFC-LOGGER - JWT Token error detected, attempting refresh');
      inMemoryJWT.ereaseAccessToken();
      const result = await inMemoryJWT.getRefreshedToken();
      if (!result) {
        console.log('BFC-LOGGER - Get Refresh Token Api Failed - forcing logout');
        inMemoryJWT.ereaseToken();
        let finalErrorMessage = `You have been logged out to protect your account.`;
        await storage.setItem('LogoutMessage', finalErrorMessage);
        // Log sudden logout before reload
        utils.logUIException('sudden_logout', { tag: 'processApiErrors.511_refresh_fail' });
        window.location.reload(false);
      } else if (result === true) {
        // sessionStorage persists across reloads of the SAME tab (unlike window.*) so the
        // reloaded page sees the flag and won't reload again — breaking the cascade.
        // Other tabs don't need to reload; they sync via the 'storage' event listener.
        const reloadKey = 'bfc_511_refreshReloaded';
        const lastReloadTime = parseInt(sessionStorage.getItem(reloadKey) || '0');
        const timeSinceLastReload = Date.now() - lastReloadTime;
        if (timeSinceLastReload > 60000) {
          console.log('BFC-LOGGER - Token refresh successful - reloading this tab');
          sessionStorage.setItem(reloadKey, String(Date.now()));
          window.location.reload(false);
        } else {
          console.log(
            `BFC-LOGGER - Token refresh successful - skipping reload (reloaded ${timeSinceLastReload}ms ago)`,
          );
        }
      } else if (result === 'REQUEST_ABORTED') {
        console.log('BFC-LOGGER - Token refresh aborted - NOT reloading page');
        // Don't reload on aborted request
      } else {
        console.log('BFC-LOGGER - Token refresh returned unexpected result:', result);
        // Only reload if we get an unexpected result - log it
        utils.logUIException('sudden_logout', { tag: 'processApiErrors.511_unexpected' });
        window.location.reload(false);
      }
    }

    if (err.status === 503) {
      store.dispatch(systemActions.updateServerUnderMaintenanceStatus(true));
      await apiErrorLogger(err);
      //   inMemoryJWT.ereaseAccessToken();
      //   inMemoryJWT.ereaseToken();
      //   let finalErrorMessage = `You have been logged out to protect your account.`;
      //   await storage.setItem('LogoutMessage', finalErrorMessage);
      //   window.location.reload(false);
    }

    // console.log('err--statusText->', err.statusText)
    // console.log('err--status->', err.status)
    // console.log('err--message->', err.message)
    // console.log('err--ok->', err.ok)

    // console.log('err--->', err)
    let body = {};
    let stacktrace;
    const errorTrace = new Error();
    const loc = window.location.href;
    const isProdInstance = loc.includes('supply.biofuelcircle.com') || loc.includes('my.biofuelcircle.com');
    try {
      // console.log('err------------------------->', err);
      stacktrace = `statusCode: ${err.status} \n ${errorTrace.stack}`;
      body = err?.status ? await err.json() : err;
      // console.log('body-------------------------->', body);
      // const backendFieldErrors = _.get(body, 'data') || _.get(body, 'errors') || {};
      const backendFieldErrors = _.isPlainObject(_.get(body, 'data'))
        ? _.get(body, 'data')
        : _.isPlainObject(_.get(body, 'errors'))
        ? _.get(body, 'errors')
        : {};
      let errMessage = _.get(body, 'message') || `Error Processing Request.${isProdInstance ? '' : ` API: ${apiName}`}`;
      // errors.message = _.get(body, 'data[0]', '');
      errMessage =
        errMessage === 'Aborted'
          ? `Request Timeout. Unable to process request.${isProdInstance ? '' : ` API: ${apiName}`} `
          : errMessage;

      const frontendFieldErrors = normalize(backendFieldErrors, 'snake');

      //removing lowerStr usage
      // for (const field of Object.keys(backendFieldErrors)) {
      //   frontendFieldErrors[utils.lowerStr(field)] = backendFieldErrors[field];
      // }

      errData.errors = {
        ...frontendFieldErrors,
        // ...backendFieldErrors,
      };
      errData['message'] = errMessage || `Unable to process request.${isProdInstance ? '' : ` API: ${apiName}`}`;
    } catch (err) {
      let statusText = _.get(err, 'statusText') || '';
      const message = _.get(body, 'message') || '';
      errData['message'] = message
        ? message
        : statusText
        ? statusText
        : `Unable to process request.${isProdInstance ? '' : ` API: ${apiName}`}`;
    }
    if (errData['message'].toString().includes('Unable to process request')) {
      try {
        let bodyString = JSON.stringify(!_.isEmpty(body) ? body : stacktrace);
        let token = inMemoryJWT.getToken() || '';
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: token },
        };
        fetch(
          `${baseUrl}/BioFuelCommonUtilities/api/CommonUtilities/InsertExceptionLog?exceptionat=${apiName}&exceptionstacktrace=${bodyString}`,
          requestOptions,
        )
          .then((response) => response.json())
          .then((data) => console.log('InsertExceptionLog--->response', data));
      } catch (err) {
        console.log('InsertExceptionLog--->error', err);
      }
    }
    return errData;
  },

  fetch(request, opts = {}, isJson = true, isSsoLogin = false, ssoId) {
    const controller = new AbortController();
    const { signal } = controller;
    const isExcluded = isExcludedFromEncryption(request);

    let token = inMemoryJWT.getToken() || '';
    if (isUserOnboardingScreen) {
      token = localStorage.getItem('accessToken') || '';
    }
    if (!token) {
      const user = window.user || {};
      token = _.get(user, 'jwttoken', '') || '';
    }
    // Allow callers to supply an Authorization token (e.g. a shared "View Contract"
    // link opened by a not-logged-in user) without clobbering the default headers
    // like `initiator`, which the API needs to decrypt the request.
    if (opts && opts.accessToken) {
      token = opts.accessToken;
      delete opts.accessToken;
    }
    // console.log('Token', token, localStorage.getItem('accessToken'));
    opts = {
      method: 'GET',
      headers: {
        Authorization: token,
        // initiator: window.btoa(iv),
        initiator: iv,
      },
      // credentials: 'include',
      ...opts,
    };
    if (isJson) {
      opts.headers['Content-Type'] = 'application/json';
    }
    if (isSsoLogin) {
      if (ssoId === 'iProfit') {
        let loc = window.location.href;
        if (loc.includes('prep') || loc.includes('test') || loc.includes('demo')) {
          opts.headers['AccessToken'] =
            'ALRjjDOrhrzwECauPuQGkviNfjJOEMqMTNXNJjPkrYYdWSueDUNRXdNzYVShfJLJZhKnymiMdOPFqnQoJXOtGmjwoFxyFWQfHXtJPYhDEzAvYTGFRKMwPhJFmUyEKcYS';
        } else if (loc.includes('my.biofuelcircle.com') || loc.includes('supply.biofuelcircle.com')) {
          opts.headers['AccessToken'] = 'DUNRXdNzYVShfJLJZhKnymiMdOPFqnQoJXOtGmjwoFxyFWQfHXtJPYhDEzAvYTGFR';
        }
      } else {
        opts.headers['pat'] = 'bd@bdc@hgvcccxzbcvbdsucbsdcsd';
      }
    }

    if (
      request?.includes('BioFuelOAuthServer/Users/login') ||
      request?.includes('BioFuelOAuthServer/Users/verify-login') ||
      request?.includes('BioFuelOAuthServer/Users/refresh-token')
    ) {
      opts.headers['AccessToken'] = requestHeaderAccessToken;
    }

    const getRequest = async (req, opts) => {
      const reqString = opts?.['body'];
      let encryptedBody = encryption(reqString);
      return crossFetch(req, { ...opts, body: encryptedBody, signal });
    };

    let urlWithEncryptedQs;
    if (isApiEncryptionEnabled === 'true' && !isExcluded) {
      const parsedUrl = new URL(request);
      if (parsedUrl.search) {
        const queryParams = parsedUrl.search.split('?')[1];
        parsedUrl.search = '';
        const isAlreadyEncrypted = decryption(queryParams);
        urlWithEncryptedQs =
          isApiEncryptionEnabled === 'true'
            ? isAlreadyEncrypted
              ? request
              : `${parsedUrl?.origin}${parsedUrl?.pathname}?${this.getQs(queryStringParser.parse(queryParams))}`
            : request;
      }
    }
    // console.log('Header-request-payload-utils->fetch', `${request} => ${JSON.stringify(opts.headers)}`);

    const req = {
      abort: () => controller.abort(),
      ready:
        isApiEncryptionEnabled === 'true' && !isExcluded
          ? opts?.['body']
            ? getRequest(urlWithEncryptedQs || request, { ...opts, signal })
            : crossFetch(urlWithEncryptedQs || request, { ...opts, signal })
          : crossFetch(request, { ...opts, signal }),
    };

    setTimeout(() => {
      req.abort();
    }, 30 * 1000);

    return req;
  },

  fetchShare(request, opts = {}, isJson = true) {
    const controller = new AbortController();
    const { signal } = controller;
    opts = {
      method: 'GET',
      headers: {},
      ...opts,
    };
    if (isJson) {
      opts.headers['Content-Type'] = 'application/json';
    }

    const getRequest = async (req, opts) => {
      const reqString = opts?.['body'];
      let encryptedBody = encryption(reqString);
      return crossFetch(req, { ...opts, body: encryptedBody, signal });
    };

    const req = {
      abort: () => controller.abort(),
      ready:
        isApiEncryptionEnabled === 'true'
          ? opts?.['body']
            ? getRequest(request, { ...opts, signal })
            : crossFetch(request, { ...opts, signal })
          : crossFetch(request, { ...opts, signal }),
    };

    setTimeout(() => {
      req.abort();
    }, 30 * 1000);

    return req;
  },

  fetchMMI(request, opts = {}, isJson = true) {
    const controller = new AbortController();

    const { signal } = controller;

    const storeState = globalThis.store.getState();
    const tokenState = _.get(storeState, 'locationEloc') || {};
    const token = _.get(tokenState, 'entities.undefined') || '';
    // console.log('token====>MMI', token);

    opts = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      // credentials: 'include',
      ...opts,
    };
    // debugger;
    if (isJson) {
      opts.headers['Content-Type'] = 'application/json';
    }

    const getRequest = async (req, opts) => {
      const reqString = opts?.['body'];
      let encryptedBody = encryption(reqString);
      return crossFetch(req, { ...opts, body: encryptedBody, signal });
    };

    const req = {
      abort: () => controller.abort(),
      ready:
        isApiEncryptionEnabled === 'true'
          ? opts?.['body']
            ? getRequest(request, { ...opts, signal })
            : crossFetch(request, { ...opts, signal })
          : crossFetch(request, { ...opts, signal }),
    };

    setTimeout(() => {
      req.abort();
    }, 30 * 1000);

    return req;
  },

  logObj(obj) {
    // console.log('\n\n=======================logObj=====================================');
    try {
      // console.log('obj---->', obj);
      // console.log('\n\n');
      for (const key in obj) {
        console.log('\nkey-->', key);
        console.log('\nval-->', obj[key]);
      }
    } catch (err) {
      console.log('unable to log obj');
    }
    // console.log('\n\n=======================logObj=====================================');
  },

  lowerStr(str = '') {
    str = str.trim().toLowerCase();
    // str = str.replace(/\./g, '')
    // str = str.replace(/\*/g, '')
    // str = str.replace(/-/g, '')
    // str = str.replace(/ /g, '')
    // str = str.replace(/_/g, '')
    str = str.replace(/[^a-z0-9]/gi, '');

    return str;
  },

  sleep(sec = 1) {
    return new Promise((resolve, rejcet) => {
      setTimeout(() => {
        resolve();
      }, sec * 1000);
    });
  },

  isNaN(value) {
    return !(!(value instanceof Array) && !isNaN(parseFloat(value)) && isFinite(value));

    // from angular
    // return !(!isNaN(value - parseFloat(value)));
  },
  isNumber(value) {
    return !utils.isNaN(value);
  },
  // isNaN(value) {

  //     return !(!(value instanceof Array) && !isNaN(parseFloat(value)) && isFinite(value))

  //     //from angular
  //     return !(!isNaN(value - parseFloat(value)));
  // },

  secToHrsMins(num) {
    if (num < 60 && num >= 30) {
      return '1 min';
    }
    if (num < 30 && num > 0) {
      return '0 min';
    }

    num = parseInt(num / 60);

    let hours = Math.floor(num / 60);
    if (hours) {
      if (hours === 1) {
        hours = `${parseInt(hours)} hr`;
      } else {
        hours = `${parseInt(hours)} hrs`;
      }
    }

    let minutes = num % 60;

    if (minutes) {
      if (minutes === 1) {
        minutes = `${parseInt(minutes)} min`;
      } else {
        minutes = `${parseInt(minutes)} mins`;
      }
    }

    let str = '';
    if (minutes) {
      str = minutes;
    }
    if (hours) {
      str = `${hours} ${str}`;
    }

    return str.trim();
  },
  padZero(str = '', size = 12) {
    str = str || '';
    let s = str.toString();
    while (s.length < (size || 2)) {
      s = `0${s}`;
    }
    return s;
  },

  wait: (time = 1) =>
    // time = time * 1000;
    // console.log(--------------wating for ${time} seconds...)
    new Promise((resolve, reject) => {
      setTimeout(() => {
        // console.log(--------------wating finish-----);
        resolve();
      }, time * 1000);
    }),

  clone: (obj) => JSON.parse(JSON.stringify(obj)),

  // Fire-and-forget UI exception logger to backend
  logUIException: async (ui_event = '', extra = {}) => {
    try {
      const token = inMemoryJWT.getToken() || '';
      const exceptionAt = encodeURIComponent(extra?.tag || ui_event || 'UIEvent');
      const rawStack = (() => {
        try {
          return new Error().stack || '';
        } catch (e) {
          return '';
        }
      })();
      const fileHint = (rawStack || '').split('\n')[2] || '';
      const stackStr = `${ui_event} | ${window?.location?.href || ''} | pid=${
        (await storage.getItem('pid')) || ''
      } | sid=${(await storage.getItem('sid')) || ''} | exp=${
        (await storage.getItem('accessTokenExpiry')) || ''
      } | source=${fileHint} | ${extra?.message || ''}`;
      const exceptionStackTrace = encodeURIComponent(stackStr);
      const url = `${baseUrl}/BioFuelCommonUtilities/api/CommonUtilities/InsertExceptionLog?ExceptionAt=${exceptionAt}&ExceptionStackTrace=${exceptionStackTrace}`;
      // Fire-and-forget with minimal headers as per swagger sample
      fetch(url, { method: 'POST', headers: { Authorization: token } }).catch(() => {});
    } catch (e) {
      // Swallow errors - logging must never break the app flow
      console.log('InsertExceptionLog error (ignored)', e);
    }
  },

  forceLogout: async () => {
    // Log the upcoming logout event for diagnostics
    utils.logUIException('force_logout', { tag: 'utils.forceLogout' });
    await storage.removeItem('refreshToken');
    // await storage.removeItem('pid');
    // await storage.removeItem('sid');
    // await storage.removeItem('persist:root');
    if (typeof window !== undefined) {
      window.location.href = '/';
    }
  },

  getRandomInt: (min, max) => Math.floor(Math.random() * (max - min + 1)) + min,

  uid: (len = 255) => {
    const buf = [];
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charlen = chars.length;

    for (let i = 0; i < len; ++i) {
      buf.push(chars[utils.getRandomInt(0, charlen - 1)]);
    }

    return buf.join('');
  },

  nl2br: (str, is_xhtml) => {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    const breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
    return `${str}`.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
  },

  isMobile: () => {
    if (window.matchMedia('(max-width: 766px)').matches) {
      return true;
      /* The viewport is at least 991.98 pixels wide */
    }
    return false;
    /* The viewport is less than 991.98 pixels wide */
  },

  isAuctionRoute: () => {
    if (location.pathname.includes('/auction')) {
      return true;
      /* The viewport is at least 991.98 pixels wide */
    }
    return false;
    /* The viewport is less than 991.98 pixels wide */
  },
  isMPARoute: () => {
    if (location.pathname.includes('/markets-live')) {
      return true;
      /* The viewport is at least 991.98 pixels wide */
    }
    return false;
    /* The viewport is less than 991.98 pixels wide */
  },

  addHandler(elSelector, eventName, selector, fn) {
    const element = document.querySelector(elSelector);

    element.addEventListener(eventName, (event) => {
      const possibleTargets = element.querySelectorAll(selector);
      const { target } = event;

      for (let i = 0, l = possibleTargets.length; i < l; i++) {
        let el = target;
        const p = possibleTargets[i];

        while (el && el !== element) {
          if (el === p) {
            return fn.call(p, event);
          }

          el = el.parentNode;
        }
      }
      return true;
    });
  },

  getURLParam: (key) => {
    const value = [];

    // eslint-disable-next-line no-undef
    const query = String(document.location).split('?');

    if (query[1]) {
      const part = query[1].split('&');

      for (let i = 0; i < part.length; i += 1) {
        const data = part[i].split('=');

        if (data[0] && data[1]) {
          value[data[0]] = data[1];
        }
      }

      if (value[key]) {
        return value[key];
      }
      return '';
    }
  },

  formatDate: (date = '') => {
    if (!dayjs(date).isValid()) {
      return 'N/A';
    }
    const formatedDate = dayjs(date).format('DD-MMM-YYYY');
    // console.log('\n------formatDate------');
    // console.log('formatDate-->', date);
    // console.log('formatted->date->', formatedDate);
    // console.log('------------------------');
    return formatedDate;
  },

  formatDateYear: (date = '') => {
    if (!dayjs(date).isValid()) {
      return 'N/A';
    }
    const formatedDate = dayjs(date).format('YYYY');
    // console.log('\n------formatDate------');
    // console.log('formatDate-->', date);
    // console.log('formatted->date->', formatedDate);
    // console.log('------------------------');
    return formatedDate;
  },

  formatDateTime: (datetime = '') => {
    if (!dayjs(datetime).isValid()) {
      return 'N/A';
    }
    return dayjs(datetime).format('DD-MMM-YYYY h:mm A');
  },

  formatToModernDateTime: (datetime = '') => {
    if (!dayjs(datetime).isValid()) {
      return 'N/A';
    }
    return `${dayjs(datetime).format('MMMM D, YYYY')} at ${dayjs(datetime).format('h:mm A')}`;
  },

  unformat: (price = 0) => {
    if (!price) {
      return '0';
    }
    // return parseFloat(price.toString().replace(/[^0-9.]/g, '')).toString(); // 12345.99
    price = price.toString();
    price = price.replace(/,/g, '');
    price = price.replace(/\$/g, '');
    price = price.replace(/[^0-9-.]/g, '');
    return price;
  },

  formatPrice: (number, removeZeros = true) => {
    // To set it up as a global function:
    number = number || 0;
    number = parseFloat(number.toString().replace(/[^0-9-.]/g, '')).toFixed(2);
    number = priceFormatter.format(number);
    if (removeZeros) {
      number = number.replace(/\D00(?=\D*$)/, '');
    }
    return number;
  },
  formatNumberPrice: (number, removeZeros = true) => {
    // To set it up as a global function:
    number = number || 0;
    number = parseFloat(number.toString().replace(/[^0-9-.]/g, '')).toFixed(2);
    number = quantityFormatter.format(number);
    if (removeZeros) {
      number = number.replace(/\D00(?=\D*$)/, '');
    }
    return number;
  },
  formatQty: (number, suffix = '', removeZeros = true) => {
    // To set it up as a global function:
    number = number || 0;
    number = parseFloat(number.toString().replace(/[^0-9-.]/g, '')).toFixed(3);

    number = quantityFormatter.format(number);
    if (removeZeros) {
      number = number.replace(/\D00(?=\D*$)/, '');
    }

    if (number == '0') {
      number = ' ';
    }

    if (suffix) {
      number = `${number} ${suffix}`;
    }

    return number;
  },

  formatQtyPriceUptoTwoDecimal: (number) => {
    // check if the number is a valid number and not null
    if (number === 0) {
      return '';
    } else {
      if (_.isNumber(number) && !_.isNull(number)) {
        return parseFloat(number).toFixed(2);
      } else {
        return '';
      }
    }
  },

  formatQtyPriceUptoTwoDecimalForStorage: (number) => {
    // check if the number is a valid number and not null
    if (number === null) {
      return '0.00';
    } else {
      if (_.isNumber(number) && !_.isNull(number)) {
        return parseFloat(number).toFixed(2);
      } else {
        return '0.00';
      }
    }
  },

  formatQtyPrice: (number, suffix = '', removeZeros = true) => {
    // To set it up as a global function:
    number = number || 0;
    number = parseFloat(number.toString().replace(/[^0-9-.]/g, '')).toFixed(3);

    number = amountFormatter.format(number);
    if (removeZeros) {
      number = number.replace(/\D00(?=\D*$)/, '');
    }

    if (suffix) {
      number = `${number} / ${suffix}`;
    }

    return number;
  },

  formatQtyPricePayment: (number, suffix = '', removeZeros = true) => {
    // To set it up as a global function:
    number = number || 0;
    number = parseFloat(number.toString().replace(/[^0-9-.]/g, '')).toFixed(3);

    const numberParts = amountFormatter.formatToParts(number);
    number = numberParts
      .filter(({ type, value }) => {
        if (type !== 'currency') {
          return value;
        }
        return false;
      })
      .map((num) => num.value)
      .reduce((string, part) => string + part);

    const currency = numberParts
      .filter(({ type, value }) => {
        if (type === 'currency') {
          return value;
        }
        return false;
      })
      .map((num) => num.value)
      .reduce((string, part) => string + part);

    if (removeZeros) {
      number = number.replace(/\D00(?=\D*$)/, '');
    }

    if (!suffix) {
      number = `${currency} ${number}`;
    }

    return number;
  },

  //periodicity_enum_code
  formatperiodicity: (periodicity) => {
    // To set it up as a global function:
    let periodicity_enum_code = periodicity?.split('Per');
    return periodicity_enum_code ? periodicity_enum_code[1] : '';
  },

  encodeBackUrl: () => {
    return btoa(window.location.pathname + window.location.search);
  },
  decodeBackUrl: (backUrl) => {
    let decodeUrl = '';
    if (backUrl !== undefined) {
      decodeUrl = atob(backUrl);
    }
    return decodeUrl;
  },

  encodeCustomUrl: (backLink) => {
    return btoa(backLink);
  },

  formatPeriodicityEnum: (periodicityEnum = 1) => {
    const PERIODICITY_ENUM_CODE_MAP = {
      1: '',
      2: 'Day',
      3: 'Week',
      4: 'Month',
    };
    return PERIODICITY_ENUM_CODE_MAP[periodicityEnum] || '';
  },

  formatQtyPricePerUOM: (number, suffix = '', removeZeros = true) => {
    // To set it up as a global function:
    number = number || 0;
    number = parseFloat(number.toString().replace(/[^0-9-.]/g, '')).toFixed(3);

    const numberParts = amountFormatter.formatToParts(number);
    number = numberParts
      .filter(({ type, value }) => {
        if (type !== 'currency') {
          return value;
        }
        return false;
      })
      .map((num) => num.value)
      .reduce((string, part) => string + part);

    const currency = numberParts
      .filter(({ type, value }) => {
        if (type === 'currency') {
          return value;
        }
        return false;
      })
      .map((num) => num.value)
      .reduce((string, part) => string + part);

    if (removeZeros) {
      number = number.replace(/\D00(?=\D*$)/, '');
    }

    if (suffix) {
      number = `${currency} ${number} /${suffix}`;
    }

    return number;
  },
  formatNegativePricePerUOM: (number, suffix = '', removeZeros = true) => {
    // To set it up as a global function:
    number = number || 0;
    number = parseFloat(number.toString().replace(/[^0-9-.]/g, '')).toFixed(3);

    const numberParts = amountFormatter.formatToParts(number);
    number = numberParts
      .filter(({ type, value }) => {
        if (type !== 'currency') {
          return value;
        }
        return false;
      })
      .map((num) => num.value)
      .reduce((string, part) => string + part);

    const currency = numberParts
      .filter(({ type, value }) => {
        if (type === 'currency') {
          return value;
        }
        return false;
      })
      .map((num) => num.value)
      .reduce((string, part) => string + part);

    if (removeZeros) {
      number = '(' + number.replace(/\D00(?=\D*$)/, '') + ')';
    }

    if (suffix) {
      number = `${currency} ${number} /${suffix}`;
    }

    return number;
  },

  // redirect: (url) => {
  //   window.location.href = url;
  // },

  /*
    /// Disabled cause need moment replacement
    getRemainingTime: datetime => {

        if (moment().isAfter(moment(datetime))) {
            return '0';
        }

        let diff = moment(datetime).unix() - moment().unix();
        const days = parseInt(diff / (24 * 60 * 60));

        diff = diff % (24 * 60 * 60);

        const hours = parseInt(diff / (60 * 60));
        diff = diff % (60 * 60);

        const mins = parseInt(diff / 60);

        return days + ' Days: ' + hours + ' Hrs: ' + mins + ' mins';
    },
    */
  formatPhone: (input) => {
    // Strip all characters from the input except digits
    input = input.replace(/\D/g, '');

    // Trim the remaining input to ten characters, to preserve phone number format
    input = input.substring(0, 10);

    // Based upon the length of the string, we add formatting as necessary
    const size = input.length;
    if (size === 0) {
      // input = input;
    } else if (size < 4) {
      input = `(${input}`;
    } else if (size < 7) {
      input = `(${input.substring(0, 3)}) ${input.substring(3, 6)}`;
    } else {
      input = `(${input.substring(0, 3)}) ${input.substring(3, 6)} - ${input.substring(6, 10)}`;
    }
    return input;
  },

  youtubeParser: (url) => {
    let youTubeLink;
    function getAllLinks(linkText) {
      return linkText.match(/<a\s+(?:[^>]*?\s+)?href="([^"]+[^"]+)"/g) || [];
    }
    let regExp =
      /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/gm;
    const youTubeLinks = getAllLinks(url).map((link) => link.slice(9, -1));

    for (let link of youTubeLinks) {
      const match = link.match(regExp);
      if (match) {
        youTubeLink = match[0];
        break;
      }
    }
    return youTubeLink;
  },

  getDistanceFromLatLong: (coords1, coords2) => {
    const toRad = (x) => {
      return (x * Math.PI) / 180;
    };

    let dLat = toRad(coords2.latitude - coords1.latitude);
    let dLon = toRad(coords2.longitude - coords1.longitude);

    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(coords1.latitude)) * Math.cos(toRad(coords2.latitude)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

    return (12742 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))).toFixed(2) + ' ' + 'km';
  },

  DeleteRequirementOrOfferForMatchingPopup: ({
    id,
    history,
    type,
    COMMODITY_TYPE,
    requirementsActions,
    offersActions,
  }) => {
    const unSubscribe = history.listen(() => {
      // console.log('MatchingPopUp .busy commodity Details', history);
      if (
        history.location.pathname === `/commodity/requirements/edit/${id}` ||
        history.location.pathname === `/commodity/offers/edit/${id}`
      ) {
        if (type === COMMODITY_TYPE.REQUIREMENTS) {
          globalThis.store.dispatch(requirementsActions.delete(id));
          return;
        }
        if (type === COMMODITY_TYPE.OFFERS) {
          globalThis.store.dispatch(offersActions.delete(id));
          return;
        }
      }
    });
    return unSubscribe;
  },

  caculateFinalQuantity,
  formatLocationString,

  // Native Format Constructor Methods
  formatPrice: (price, country = 'en-IN', currency = 'INR', maximumFractionDigits = 3, options) =>
    new Intl.NumberFormat(country, { style: 'currency', currency, maximumFractionDigits, ...options }).format(price),
  formatPriceWithoutDecimal: (price, country = 'en-IN', currency = 'INR', maximumFractionDigits = 0) =>
    new Intl.NumberFormat(country, { style: 'currency', currency, maximumFractionDigits }).format(price),
  formatNumber: (number, country = 'en-IN', maximumFractionDigits = 4) => {
    let formattedPrice = new Intl.NumberFormat(country, maximumFractionDigits ? { maximumFractionDigits } : {}).format(
      number,
    );
    if (number.includes('.', number.length - 1)) {
      formattedPrice = formattedPrice + '.';
    }
    return formattedPrice;
  },

  getSearchParams: () => {
    const url = new URL(getDecryptedUrl(window.location.href));
    let params = new URLSearchParams(url?.search);
    if (params?.size) {
      params?.delete('page');
      params?.delete('back');
      return params?.toString();
    }
  },

  generateLastFiveYears: () => {
    const currentYear = new Date().getFullYear();
    const currentFinancialYear = new Date().getMonth() < 3 ? currentYear - 1 : currentYear;
    const years = [];
    for (let i = 0; i < 5; i++) {
      const startYear = currentFinancialYear - i;
      const endYear = startYear + 1;
      const label = `${startYear}-${endYear.toString().slice(-2)}`;
      const value = `${startYear}-${endYear}`;
      years.push({ label: label, value: value });
    }
    return years;
  },

  dynamicRangeFilters: () => {
    const now = dayjs();
    const currentDate = now.toDate();

    // Helper function to get start and end of fiscal year
    const getFiscalYearRange = (year) => {
      const startDate = dayjs(`${year}-04-01`).startOf('day');
      const endDate = dayjs(`${year + 1}-03-31`).endOf('day');
      return { startDate: startDate.toDate(), endDate: endDate.toDate() };
    };

    // Get current fiscal year
    const currentMonth = now.month() + 1; // dayjs months are 0-indexed
    const currentFiscalYear = currentMonth >= 4 ? now.year() : now.year() - 1;

    const filters = [
      {
        label: 'Current Week',
        value: 'currentWeek',
        startDate: now.startOf('week').format('YYYY-MM-DD'),
        endDate: now.endOf('week').format('YYYY-MM-DD'),
      },
      {
        label: 'Current Month',
        value: 'currentMonth',
        startDate: now.startOf('month').format('YYYY-MM-DD'),
        endDate: now.endOf('month').format('YYYY-MM-DD'),
      },
      {
        label: 'Last Month',
        value: 'lastMonth',
        startDate: now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        endDate: now.subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
      },
      {
        label: 'Last 3 Months',
        value: 'last3Months',
        startDate: now.subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
        endDate: now.subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
      },
      {
        label: 'Last 6 Months',
        value: 'last6Months',
        startDate: now.subtract(6, 'month').startOf('month').format('YYYY-MM-DD'),
        endDate: now.subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
      },
      {
        label: 'Current Fiscal Year',
        value: 'currentFiscalYear',
        startDate: dayjs(`${currentFiscalYear}-04-01`).format('YYYY-MM-DD'),
        endDate: dayjs(`${currentFiscalYear + 1}-03-31`).format('YYYY-MM-DD'),
      },
      {
        label: 'Last Fiscal Year',
        value: 'lastFiscalYear',
        startDate: dayjs(`${currentFiscalYear - 1}-04-01`).format('YYYY-MM-DD'),
        endDate: dayjs(`${currentFiscalYear}-03-31`).format('YYYY-MM-DD'),
      },
      {
        label: 'Custom Date',
        value: 'customDate',
        startDate: null,
        endDate: null,
        isCustom: true,
      },
    ];

    return filters;
  },
};

export default utils;

/**
 * Lighten or Darken Color
 *
 * The CSS preprocessors Sass and LESS can take any color and darken() or
 * lighten() it by a specific value. But no such ability is built into
 * JavaScript. This function takes colors in hex format (i.e. #F06D06, with or
 * without hash) and lightens or darkens them with a value.
 *
 * @param {String} colorCode The hex color code (with or without # prefix).
 * @param {Int} amount
 */
export const LightenDarkenColor = (colorCode, amount) => {
  let usePound = false;

  if (colorCode[0] === '#') {
    colorCode = colorCode.slice(1);
    usePound = true;
  }

  const num = parseInt(colorCode, 16);

  let r = (num >> 16) + amount;

  if (r > 255) {
    r = 255;
  } else if (r < 0) {
    r = 0;
  }

  let b = ((num >> 8) & 0x00ff) + amount;

  if (b > 255) {
    b = 255;
  } else if (b < 0) {
    b = 0;
  }

  let g = (num & 0x0000ff) + amount;

  if (g > 255) {
    g = 255;
  } else if (g < 0) {
    g = 0;
  }

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};

export const ColorLuminance = (hex, lum) => {
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  lum = lum || 0;

  // convert to decimal and change luminosity
  let rgb = '#';
  let c;
  let i;
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += `00${c}`.substr(c.length);
  }

  return rgb;
};

const formatPrice = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const useAnalyticsEventTracker = () => {
  const eventTracker = (eventCategory) => {
    // console.log('hitType, eventCategory, eventAction,eventLabel<-->', eventCategory);
    ReactGA.send(eventCategory);
    // console.log('Update_Supplier_Profile',ReactGA.ga('event', 'Update_Supplier_Profile', { ProfileData : params }))
    //gtag('event', 'Update_Supplier_Profile', { ProfileData : params })
    // ReactGA.event(eventCategory)
  };
  return eventTracker;
};

export const compareDates = (dateA, dateB) => {
  const parsedDateA = new Date(dateA);
  const parsedDateB = new Date(dateB);

  // Log the dates for debugging
  console.log('Comparing dates:', parsedDateA, parsedDateB);

  // Handle invalid dates
  if (isNaN(parsedDateA) && isNaN(parsedDateB)) return 0;
  if (isNaN(parsedDateA)) return 1;
  if (isNaN(parsedDateB)) return -1;

  return parsedDateA - parsedDateB;
};

export const useIsMobile = (breakpoint = 576) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export function isOnlyFtkRoles() {
  const rolesArray = useSelector((state) => state.user?.profile?.person_role) || [];
  if (!Array.isArray(rolesArray) || rolesArray.length === 0) return false;
  const myBiofuelCircle = 'myBiofuelCircle';
  const ftk_tester = 'FTK Tester';

  const ids = new Set(rolesArray.map((r) => Number(r.role_id ?? r)).filter((n) => !Number.isNaN(n)));

  const codes = new Set(rolesArray.map((r) => (r.role_code || '').toString().trim()).filter((s) => s.length > 0));

  // must contain exactly two ids/codes
  return codes.size === 2 && codes.has(myBiofuelCircle) && codes.has(ftk_tester);
  // return ids.size === 2 && ids.has(7) && ids.has(62);
}

export function useIsMarketDealsEnabled() {
  const roles = useSelector((state) => state.rolesAndRights);
  const rolesList = roles?.entities ? Object.values(roles.entities) : Array.isArray(roles) ? roles : [];

  // Tolerant match: either module_name === 'MarketDeals' OR module_name === 'Market' && sub_module_name === 'MarketDeals'
  const record = rolesList.find(
    (x) => String(x?.module_name).trim() === 'Market' && String(x?.sub_module_name).trim() === 'MarketDeals',
  );

  const full_access = Boolean(_.get(record, 'full_access'));
  const read_access = Boolean(_.get(record, 'read_access'));
  const no_access = Boolean(_.get(record, 'no_access'));

  return {
    market_deals_found: Boolean(record),
    market_deals_enabled: full_access || read_access,
    market_deals_full_access: full_access,
    market_deals_read_access: read_access,
    market_deals_no_access: no_access,
  };
}

export function useIsMarketQualityServicesEnabled() {
  const roles = useSelector((state) => state.rolesAndRights);
  const rolesList = roles?.entities ? Object.values(roles.entities) : Array.isArray(roles) ? roles : [];

  // Tolerant match: either module_name === 'MarketDeals' OR module_name === 'Market' && sub_module_name === 'MarketQualityServices'
  const record = rolesList.find(
    (x) => String(x?.module_name).trim() === 'Market' && String(x?.sub_module_name).trim() === 'MarketQualityServices',
  );

  const full_access = Boolean(_.get(record, 'full_access'));
  const read_access = Boolean(_.get(record, 'read_access'));
  const no_access = Boolean(_.get(record, 'no_access'));

  return {
    market_quality_services_found: Boolean(record),
    market_quality_services_enabled: full_access || read_access,
    market_quality_services_full_access: full_access,
    market_quality_services_read_access: read_access,
    market_quality_services_no_access: no_access,
  };
}

let environment = 'localhost';
if (window.location.href.includes('https://my.biofuelcircle.com')) {
  environment = 'production';
} else if (window.location.href.includes('https://supply.biofuelcircle.com')) {
  environment = 'production';
} else if (window.location.href.includes('prep')) {
  environment = 'prep';
} else if (window.location.href.includes('test')) {
  environment = 'test';
} else if (window.location.href.includes('demo')) {
  environment = 'demo';
} else if (window.location.href.includes('staging')) {
  environment = 'staging';
} else if (window.location.href.includes('dev')) {
  environment = 'dev';
}

// for testing on localhost
// export const FLUX_ORIGIN = 'http://localhost:3000';
export const FLUX_ORIGIN =
  environment === 'production' ? 'https://flux.my.biofuelcircle.com' : 'https://flux.prep.biofuelcircle.com';

export const handleFluxNavigation = async () => {
  const win = window.open(`${FLUX_ORIGIN}/flux`, '_blank');

  if (!win) {
    alert('Popup blocked. Please allow popups.');
    return;
  }
};
